import React from "react";
import OrderField from "../shared/order_field";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAdvance } from "../../../queries";
import SpinLoading from "../../../../shared/spin_loading";

const OrderAdvances = ({ seasonId, dateStart, advancePrice }) => {
  const advanceQuery = useQuery(["advance"], () =>
    getAdvance({ seasonId, dateStart: dateStart })
  );

  return (
    <OrderField title={I18n.t("js.order.fields.advance")}>
      <div className="order-form__block-content row">
        <>
          {advancePrice && (
            <div
              className="col-lg-4 main-content"
              style={{ marginBottom: "auto" }}
            >
              <div className="total-price col-md-5 col-lg-6">
                <span
                  className="advance"
                  style={{ color: "#d72567", fontWeight: "900" }}
                >
                  <span className="final-advance">
                    <span className="price">
                      <span className="result-price">
                        {advancePrice?.toLocaleString("cs")}
                      </span>
                    </span>
                  </span>
                  <span className="unit"> {I18n.t("js.czk")}</span>
                </span>
              </div>
            </div>
          )}
          {advanceQuery.data && (
            <div
              className={`col-lg-${advancePrice ? "8" : "12"} aside-content`}
            >
              <div className="alert alert--col">
                <i className="fas fa-info" />
                <p
                  dangerouslySetInnerHTML={{
                    __html: advanceQuery.data?.description,
                  }}
                />
              </div>
            </div>
          )}
        </>
      </div>
    </OrderField>
  );
};

export default OrderAdvances;
